'use strict';

class InPageNavigation {
  constructor(node) {
    this.rootElement = node;
    this.sectionElements = Array.from(this.rootElement.querySelectorAll('.c-tab-navigation-tablist__item'));
    this.subMenuElements = Array.from(this.rootElement.querySelectorAll('.has-submenu'));
    this.allSections = document.querySelectorAll('[id^=\'c\']');
    this.sectionElements.forEach((sectionElement) => sectionElement.addEventListener('click', this.onClick.bind(this)));
    this.subMenuElements.forEach((subMenuElement) => subMenuElement.addEventListener('click', this.openSubmenu.bind(this)));

    const observerOptions = {
      root: document,
      rootMargin: '-25% 0px -75% 0px',
      threshold: 0,
    }

    this.intersection = new IntersectionObserver(this.intersectionObserver.bind(this), observerOptions);
    this.allSections.forEach((section) => { this.intersection.observe(section) });
  }

  onClick(event) {
    this.sectionElements.forEach((sectionElement) => sectionElement.classList.remove('is-active'));
    const el = event.target.closest('.c-tab-navigation-tablist__item');
    if (!el.classList.contains('is-active')) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  }

  intersectionObserver(entries) {
    entries.forEach((entry) => {
      const elementId = entry.target.id;
      const sectionTarget = document.querySelector(`a[href$="#${elementId}"]`);
      if (sectionTarget) {
        (entry.isIntersecting) ?
          (!sectionTarget.parentElement.classList.contains('is-active') && !sectionTarget.parentElement.classList.contains('c-button')) ?
            sectionTarget.parentElement.classList.add('is-active') : '' : sectionTarget.parentElement.classList.remove('is-active');
      }
    });
  }

  openSubmenu(event) {
    event.preventDefault();
    const el = event.target;
    const icon = el.querySelector('.c-icon') || el.closest('.c-anchor').querySelector('.c-icon');
    const submenu = el.closest('.c-tab-navigation-tablist__item').querySelector('.c-tab-navigation-tablist__item--subpages-list');

    if (el && icon.classList.contains('bi-chevron-down')) {
      icon.classList.remove('bi-chevron-down');
      icon.classList.add('bi-chevron-up');
    } else {
      icon.classList.add('bi-chevron-down');
      icon.classList.remove('bi-chevron-up');
    }

    if(submenu.classList.contains('is-hidden')) {
      submenu.classList.remove('is-hidden');
    } else {
      submenu.classList.add('is-hidden');
    }
  }
}

const inPageNavigation = document.querySelector('.c-local-navigation--horizontal');
new InPageNavigation(inPageNavigation);

